<template>
	<div class="footer">
		<div style="background-color:#383d61" class="footer--bg"></div>
		<div class="footer--inner">
			<div class="am-g">
				<div class="am-u-md-3 ">
					<div class="footer_main--column">
						<strong class="footer_main--column_title">Product</strong>
						<ul class="footer_navigation">
							<li class="footer_navigation--item"><router-link to="/product" class="footer_navigation--link">Foreign trade e-commerce</router-link></li>
							<li class="footer_navigation--item"><router-link to="/product" class="footer_navigation--link">Game collection</router-link></li>
							<li class="footer_navigation--item"><router-link to="/product" class="footer_navigation--link">Education abroad</router-link></li>
						</ul>
					</div>
				</div>
				<div class="am-u-md-6 ">
					<div class="footer_main--column">
						<strong class="footer_main--column_title">About</strong>
						<div class="footer_about">
							<p class="footer_about--text">
                We provide a secure, convenient, non-inductive and fast aggregate payment platform to help merchants better pay their orders, and all merchants can access our payment platform without a threshold.
              </p>
						</div>
            <ul class="footer_navigation" style="width: 200px">
              <li class="footer_contact_info--item" style="cursor: pointer" @click="jumpToPrivacy">Privacy Policy</li>
              <li class="footer_contact_info--item" style="cursor: pointer"  @click="jumpToTerms">Terms of Service</li>
            </ul>
					</div>
				</div>
				<div class="am-u-md-3 ">
					<div class="footer_main--column">
						<strong class="footer_main--column_title">Contact</strong>
						<ul class="footer_contact_info">
							<li class="footer_contact_info--item"><i class="am-icon-phone"></i><span>Tel：+6566888590</span><br><span>Email: airuipaysupport@gmail.com</span></li>
							<li class="footer_contact_info--item"><i class="am-icon-map-marker"></i><span>111 NORTH BRIDGE ROAD #29-06A PENINSULA PLAZA SINGAPORE (179098)</span></li>
							<li class="footer_contact_info--item"><i class="am-icon-clock-o"></i><span>Monday ~ Saturday, 8:00 - 23:00 </span></li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Footer",
  methods:{
    jumpToPrivacy(){
      window.open(window.origin+'/privacy-policy.html')
    },
    jumpToTerms(){
      window.open(window.origin+'/terms-of-service.html')
    }
  }
}
</script>

<style scoped>

</style>
